var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer h-full flex items-center no-underline text-primary",on:{"click":_vm.downloadCSV}},[_c('i',{staticClass:"fa fa-download mr-2"}),_c('span',{staticClass:"uppercase"},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }